export { MakeModelIcon } from './make-model'
